import * as type from '../types/uiTypes'
//Action Creator
export const setPenId = (payload) => ({
    type: type.SET_PEN_ID
});

export const setPenLoading = (payload) => ({
    type: type.SET_PEN_LOADING,
    payload
});

export const setSaveBtnTxt = (payload) => ({
    type: type.SET_SAVE_BTN_TXT,
    payload
});

export const setForkBtnTxt = (payload) => ({
    type: type.SET_FORK_BTN_TXT,
    payload
});

export const setPopUp = (payload) => ({
    type: type.SET_POPUP,
    payload
});


// WEBPACK FOOTER //
// ./src/redux/actions/uiActions.js